"use client";

import * as React from "react";
import { Search, X } from "lucide-react";
import { cn } from "../cn";

export type FilterSearchProps = {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  className?: string;
  /** Width class. Defaults to a sensible toolbar width. */
  width?: string;
};

export const FilterSearch = React.forwardRef<
  HTMLInputElement,
  FilterSearchProps
>(
  (
    { value, onChange, placeholder, className, width = "w-full sm:w-72" },
    ref,
  ) => {
    return (
      <div className={cn("relative", width)}>
        <Search
          className="pointer-events-none absolute left-3 top-1/2 -translate-y-1/2 text-ash"
          size={15}
          strokeWidth={2}
          aria-hidden
        />
        <input
          ref={ref}
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={cn(
            "h-10 w-full rounded-[var(--radius-sm)] border-[1.5px] border-smoke bg-mist",
            "pl-9 pr-9 text-sm font-satoshi font-medium text-ink placeholder:text-ash",
            "outline-none transition-colors",
            "focus:border-lime focus:bg-paper",
            className,
          )}
        />
        {value ? (
          <button
            type="button"
            onClick={() => onChange("")}
            aria-label="Xoá tìm kiếm"
            className="absolute right-2 top-1/2 -translate-y-1/2 inline-flex h-6 w-6 items-center justify-center rounded-full text-ash hover:bg-smoke hover:text-ink"
          >
            <X size={13} strokeWidth={2.25} />
          </button>
        ) : null}
      </div>
    );
  },
);
FilterSearch.displayName = "FilterSearch";
